import Wordmark from "./Wordmark";
import LegalLinks from "./LegalLinks";
import Channels from "./Channels";
import { ADDRESS, PHONE_DISPLAY, PHONE_E164 } from "@/lib/contact";
import { useT } from "@/i18n";

/** Subsolul.
 *
 *  Era copiat în cinci pagini, identic. Adăugarea unei singure modalități de
 *  contact însemna cinci editări care puteau devia una de alta — de aceea e
 *  acum un component. Variantele care chiar diferă (pagina de caz, care
 *  numără cazurile; 404 și legalele, care n-au drepturi de autor pe ele) își
 *  păstrează forma prin `note` și `bare`. */

/** Adresa și telefonul, pe fiecare pagină.
 *
 *  Nu e decor. Structured data declară `telephone` și `streetAddress` pe nodul
 *  studioului, care se emite peste tot, în timp ce site-ul le arăta doar pe
 *  /contact: 257 din 260 de pagini afirmau în marcaj ceva ce cititorul nu putea
 *  vedea. Regula lui Google e că marcajul descrie pagina, iar o afirmație care
 *  trăiește doar în JSON-LD e exact motivul pentru care se dau acțiuni manuale
 *  de spam de date structurate. crawlview a prins-o pe toate 257.
 *
 *  Se randează și în varianta `bare`. Paginile de caz, de nișă, articolele și
 *  404 folosesc `bare` — adică tocmai majoritatea celor 257. Un NAP care apare
 *  doar pe jumătate din site rezolvă jumătate din problemă.
 *
 *  Forma rămâne aceeași în toate cele trei limbi, inclusiv „Chișinău" cu
 *  diacritice în pagina rusă. Nu e o scăpare de traducere: Google compară
 *  numele, adresa și telefonul dintre fișa de business și site literal, iar
 *  „Кишинёв" ar fi pentru el o a doua adresă, nu aceeași scrisă altfel. */
export function Nap() {
  const t = useT();
  return (
    <span className="footnap">
      {/* Un singur nod de text, nu trei expresii lipite: React SSR pune un
          `<!-- -->` între ele, iar adresa ajunge în HTML tăiată de comentarii.
          Orice extractor serios le ignoră, dar cel care verifică potrivirea
          dintre marcaj și pagină n-are niciun motiv să fie pus la încercare. */}
      <span>{`${ADDRESS.street}, ${ADDRESS.locality} ${ADDRESS.postalCode}`}</span>
      {/* Programul, din același motiv ca adresa: nodul de studio îl declară
          prin `openingHoursSpecification` pe fiecare pagină, iar pagina îl
          scria doar la /contact. crawlview nu l-a raportat — verifică cheia
          `openingHours`, nu forma structurată — dar regula e aceeași, și un
          singur caz rămas pe dinafară n-ar fi rezolvat nimic, doar ar fi
          scăpat de verificator. E și textul din fișa Google, cuvânt cu cuvânt. */}
      <span>{t.contactPage.hours}</span>
      <a href={`tel:${PHONE_E164}`}>{PHONE_DISPLAY}</a>
    </span>
  );
}

export default function SiteFooter({ note, bare = false }: { note?: string; bare?: boolean }) {
  const t = useT();
  return (
    <footer>
      <Wordmark size={13.5} />
      {bare ? null : <span>{t.footer.rights}</span>}
      {note ? <span>{note}</span> : bare ? null : <span>{t.footer.reach}</span>}
      <Nap />
      <span className="footchans"><Channels /></span>
      <LegalLinks />
    </footer>
  );
}
